import React, { useCallback } from "react";
import PlayerStats from "../search/PlayerStats";
import PlayerMatches from "../search/PlayerMatches";
import PlayerHighlights from "../search/PlayerHighlights";
import PlayerTransfers from "../search/PlayerTransfers";
import InjuryHistoryBlock from "../common/InjuryHistoryBlock";
import PlayerValue from "../search/PlayerValue";
import PlayerAttributes from "../search/PlayerAttributes";

const ProfileContent = ({
  player,
  playerId,
  activeTab,
  injuries = null, // Paket Injuries: history block under the transfers
  attributes,
  uniqueTournaments,
  setAttributes,
  setUniqueTournaments,
  highlightsRefreshKey,
  // Props for PlayerStats
  seasonStats,
  seasonOptions,
  selectedSeasonId,
  setSelectedSeasonId,
  statsLoading,
  ratingChartData,
  selectedMatch,
  ratingsLoading,
  ratingsError,
}) => {
  const renderContent = useCallback(() => {
    if (!player) return null;

    const identifiers = {
      wyscoutId: player?.player?.id || null,
      sportmonksId:
        player.sportmonks_player_id || player.sportmonks_id || player.id,
      sofascoreId: player.sofascore_id || player.sofascoreId || null,
    };

    // Prepare player data with identifiers for PlayerStats
    const playerDataWithIdentifiers = {
      ...player,
      identifiers: identifiers,
    };

    switch (activeTab) {
      case "statistics":
        return (
          <PlayerStats
            playerData={playerDataWithIdentifiers}
            playerId={playerId}
            attributes={attributes}
            uniqueTournaments={uniqueTournaments}
            setAttributes={setAttributes}
            setUniqueTournaments={setUniqueTournaments}
            // Pass down hoisted stats props
            seasonStats={seasonStats}
            seasonOptions={seasonOptions}
            selectedSeasonId={selectedSeasonId}
            setSelectedSeasonId={setSelectedSeasonId}
            statsLoading={statsLoading}
            ratingChartData={ratingChartData}
            selectedMatch={selectedMatch}
            ratingsLoading={ratingsLoading}
            ratingsError={ratingsError}
          />
        );
      case "matches":
        return (
          <PlayerMatches
            identifiers={identifiers}
            playerData={playerDataWithIdentifiers}
          />
        );
      case "attributes":
        return (
          <PlayerAttributes
            playerId={playerId}
            primaryPosition={
              player?.player?.tp_detailed_position?.primary_position ||
              player?.player?.position ||
              player?.player?.main_position ||
              player?.position ||
              null
            }
          />
        );
      case "value":
        return <PlayerValue playerId={playerId} />;
      case "transfers":
        return (
          <>
            <PlayerTransfers playerId={playerId} />
            <InjuryHistoryBlock injuries={injuries} />
          </>
        );
      case "highlights":
        return (
          <PlayerHighlights
            identifiers={identifiers}
            refreshKey={highlightsRefreshKey}
          />
        );
      default:
        return null;
    }
  }, [
    player,
    activeTab,
    playerId,
    attributes,
    uniqueTournaments,
    setAttributes,
    setUniqueTournaments,
    highlightsRefreshKey,
    injuries,
    seasonStats,
    seasonOptions,
    selectedSeasonId,
    setSelectedSeasonId,
    statsLoading,
    ratingChartData,
    selectedMatch,
    ratingsLoading,
    ratingsError,
  ]);

  return (
    <div className="w-full mx-auto px-4 md:px-12 md:py-8 bg-white">
      {renderContent()}
    </div>
  );
};

export default ProfileContent;
